var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 20 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M4 4.899h2.4M4 9.099h7.2m-7.2 2.4h7.2m-7.2 2.4h2.4m-3.6 3h9.6a1.2 1.2 0 0 0 1.2-1.2v-13.2a1.2 1.2 0 0 0-1.2-1.2H2.8a1.2 1.2 0 0 0-1.2 1.2v13.2a1.2 1.2 0 0 0 1.2 1.2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  strokeWidth: 1.2,
  d: "M11.2 5.2a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6Z"
}))));
export default SvgReport;